const searchTextReducer = (previousState = "", { type, payload }) => {
    if (type === 'UPDATE_SEARCH_TEXT') {
        return payload.searchText;
    }
    return previousState;
}
export default searchTextReducer;